module.exports = "<img\r\n  ng-if=\"avatar.file\"\r\n  domain-image=\"avatar.model.avatar\"\r\n  target-width=\"avatar.targetWidth\"\r\n  target-height=\"avatar.targetHeight\"\r\n  crop-target=\"avatar.cropTarget\"\r\n  placeholder=\"{{avatar.placeholderUrl}}\">\r\n<span\r\n  class=\"avatar-initials\"\r\n  ng-style=\"{'background-color': avatar.getAvatarColor(), color: avatar.getAvatarFontColor()}\"\r\n  ng-class=\"{'long-initials': avatar.getAvatarText().length > 2}\"\r\n  ng-show=\"!avatar.file\">\r\n    {{avatar.getAvatarText()}}\r\n</span>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/js/files/directives/avatar.html
// module id = 3332
// module chunks = 0